/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Show_Book_ButtonInputs */

const fr_label_show_book_button = /** @type {(inputs: Label_Show_Book_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bouton Réserver`)
};

const en_label_show_book_button = /** @type {(inputs: Label_Show_Book_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book button`)
};

/**
* | output |
* | --- |
* | "Book button" |
*
* @param {Label_Show_Book_ButtonInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_show_book_button = /** @type {((inputs?: Label_Show_Book_ButtonInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Show_Book_ButtonInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_show_book_button(inputs)
	return en_label_show_book_button(inputs)
});